import TileClass, * as TileModule from './../node_modules/ol/Tile.js';

// Create a wrapper class
class Tile extends TileClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in TileModule) {
    if (key !== "default") {
        Tile[key] = TileModule[key];
    }
}

export default Tile;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/Tile.js';